import { createFileRoute, useNavigate } from '@tanstack/react-router'
import SlideWizard from '@/components/learning-paths/SlideWizard'
import { whatToDoV2Chapter } from '@/learning-paths/incode/what-to-do-v2/chapter'

export const Route = createFileRoute('/_auth/learning-journeys/what-to-do-after-a-scam')({
  component: WhatToDoV2Route,
})

function WhatToDoV2Route() {
  const navigate = useNavigate()

  const handleExit = () => {
    navigate({
      to: '/learning-journeys/scam-fundamentals',
      search: { invitationcode: undefined, __clerk_ticket: undefined },
    })
  }

  return (
    <SlideWizard
      chapter={whatToDoV2Chapter}
      onExit={handleExit}
      onComplete={handleExit}
    />
  )
}
